import { render, staticRenderFns } from "./AutocompleteComp.vue?vue&type=template&id=556df31b&"
import script from "./AutocompleteComp.vue?vue&type=script&lang=js&"
export * from "./AutocompleteComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports